import React, {Suspense} from 'react';
import Header from "./header";
import Footer from "./footer";
import SideBar from "./asidebar";
import {Navigate, Outlet} from "react-router-dom";
import PrescriptionDetail from '../../pages/doctor/prescriptionDetail';
import PrintSale from '../../pages/sales/check1';
// import PrintSale from '../../pages/sales/printSale';

// const Scripts = React.lazy(() => import('./scripts.js'))

const isLoggedIn = localStorage.getItem("token") ? true : false;

export default function SaleLayout(props) {
    return isLoggedIn ? (
        <>
            <div className="container-scroller">
               
                <div className="container-fluid slip">

                   
                    {/* <div className="main-panel  mt-4"> */}
                       
                            <PrintSale/>
                   
                       

                    {/* </div> */}
                </div>
            </div>

        </>) : (
        <Navigate replace to="/login"/>
    )
}
